var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useEffect, useState } from 'react';
import { apiGetListProfessionalRfpOffered } from '@/actions/ProfessionalMyPageRfpActions';
import { wrapDispatch } from '@/utils/actions/dispatch';
/**
 * 提案済みのプロジェクト
 * @param args
 */
export const useMyPageRfpOffered = (args) => {
    const { dispatch, isUseProffit, unmountRef } = args;
    const [page, changePage] = useState(1);
    const [data, changeData] = useState({});
    const [loadings, changeLoadings] = useState({});
    const [errors, changeErrors] = useState({});
    // APIの読み込み
    const loadOffered = useCallback((callPage) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            changeLoadings((prev) => (Object.assign(Object.assign({}, prev), { [callPage]: true })));
            const response = yield wrapDispatch(dispatch, apiGetListProfessionalRfpOffered({ query: { page: callPage } }, {}));
            if (!unmountRef.current) {
                changeData((prev) => (Object.assign(Object.assign({}, prev), { [callPage]: response })));
            }
        }
        catch (e) {
            if (!unmountRef.current) {
                changeErrors((prev) => (Object.assign(Object.assign({}, prev), { [callPage]: false })));
                throw e;
            }
        }
        finally {
            if (!unmountRef.current) {
                changeLoadings((prev) => (Object.assign(Object.assign({}, prev), { [callPage]: false })));
            }
        }
    }), [changeData, changeLoadings, unmountRef, dispatch]);
    // 初回ロード＋ページ変更
    useEffect(() => {
        if (!isUseProffit) {
            return;
        }
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            yield loadOffered(page);
        }))();
    }, [isUseProffit, loadOffered, page]);
    // ページ変更
    const onPageChange = useCallback((selected) => {
        changePage(selected + 1);
    }, [changePage]);
    return {
        data: data[page] || undefined,
        isError: errors[page] || false,
        loading: loadings[page] || false,
        onPageChange,
        page,
    };
};
